import { queryClient, apiRequest } from "../lib/queryClient";

const soundKey = "sound";

export function useSound(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchSound = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/choose-sound?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createSound = async (pageData) => {
    const response = await apiRequest("/admin/choose-sound", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  const updateContent = async (pageData) => {
    const { _id, ...rest } = pageData;
    const response = await apiRequest(`/admin/choose-sound/${_id}`, {
      method: "PUT",
      body: JSON.stringify(rest),
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  const deleteContent = async (pageId) => {
    await apiRequest(`/admin/choose-sound/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return pageId;
  };

  const fileUpload = async (formData) => {
    const response = await apiRequest("/file/upload", {
      method: "POST",
      body: formData,
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  const toggleSoundStatus = async (id) => {
    const response = await apiRequest(`/admin/choose-sound/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  const toggleDefaultSound = async (id) => {
    const response = await apiRequest(`/admin/choose-sound/default/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  const toggleIsExclusive = async (id) => {
    const response = await apiRequest(`/admin/choose-sound/exclusive/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [soundKey] });
    return response;
  };

  return {
    fetchSound,
    createSound,
    updateContent,
    deleteContent,
    fileUpload,
    toggleSoundStatus,
    toggleDefaultSound,
    toggleIsExclusive
  };
}
